import { Common, color } from '@stockbit/ui';
import BaseSlider from 'react-slick';
import styled from 'styled-components';

const { Flex, Button, Iconmoon } = Common;

const Container = styled.div`
  position: relative;
  background: ${color.light};

  .slick-disabled {
    opacity: 0% !important;
  }
`;

const BoxWrapper = styled.div`
  width: 163px;
`;

const BoxContainer = styled(Flex).attrs({
  direction: 'column',
  justify: 'space-between',
  align: 'center',
})`
  background: ${color.light};
  border: 1px solid ${color.downgray};
  border-radius: 4px;
  padding: 16px;
  height: 217px;
  position: relative;
  cursor: pointer;
`;

const Navigation = styled(Button)
  .attrs({ p: '0' })
  .withConfig({
    shouldForwardProp: (props: string) => !['isVisible'].includes(props),
  })
  .attrs((props) => ({
    height: '40px',
    padding: '5px',
    isVisible: props.isVisible,
  }))`
    opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
    position: absolute;
    z-index : 2;
    top: 75px;
`;

const PrevButton = styled(Navigation)`
  left: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
`;
const NextButton = styled(Navigation)`
  right: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
`;

const Wrapper = styled.div`
  height: 290px;
  border-bottom: solid 1px ${color.gainsboro};
  padding: 16px 20px;
`;

const CloseIconWrapper = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
`;

const CloseIcon = styled(Iconmoon).attrs({
  className: 'icon-widget_close',
})`
  left: -20px;
  height: 16px;
  width: 16px;
`;

const Slider = styled(BaseSlider)`
  .slick-slide {
    width: 175px !important;
    margin-right: 12px;
  }

  .slick-track {
    display: flex !important;
  }
`;

export {
  Container,
  BoxWrapper,
  BoxContainer,
  PrevButton,
  NextButton,
  Wrapper,
  CloseIconWrapper,
  CloseIcon,
  Slider,
};
